import { render, staticRenderFns } from "./SecondMenu.vue?vue&type=template&id=73cef563&scoped=true"
import script from "./SecondMenu.vue?vue&type=script&lang=js"
export * from "./SecondMenu.vue?vue&type=script&lang=js"
import style0 from "./SecondMenu.vue?vue&type=style&index=0&id=73cef563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cef563",
  null
  
)

export default component.exports